
<div class="card">
    <div class="card-body">
        <h4 class="card-title">Editar preguntas</h4>

        <table class="table table-bordered table-hover " >
            <thead>
                <tr>
                    <th>Pos</th>
                    <th >Titulo</th>
                    <th >Opción A</th>
                    <th >Opción B</th>
                    <th >Opción C</th>
                    <th >Editar/Borrar</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let question of questions; index as i">
                    <td>{{i+1}}</td>
                    <td >{{question.title}}</td>
                    <td class="footable-visible">{{question.opcA.text}}</td>
                    <td class="footable-visible">{{question.opcB.text}}</td>
                    <td class="footable-visible">{{question.opcC.text}}</td>
                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="handleEdit(question._id)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id)" ><i class="fa fa-eraser" ></i></button>
                    </td>
                </tr>
            </tbody>
     
        </table>
    </div>
</div>

<div id="myModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-lg p-20">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">PF 16</h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <form [formGroup]="pf16Form" (ngSubmit)="update()">
                <div class="form-body">
                    <h3 class="card-title">Datos de la pregunta</h3>
                    <hr>
                    <div class="row p-t-20 ">
                        <div class="col-md-10">
                            <div class="form-group">
                                <label class="control-label">Título</label>
                                <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                            </div>
                        </div>
                        <!--/span-->
                        <div class="row " formGroupName="opcA">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Texto opción A</label>
                                    <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                </div>
                            </div>
                            <div class="col-md-6">    
                                <div class="form-group">
                                    <label class="control-label">Puntaje opción A</label>
                                    <input formControlName="value" type="number" class="form-control" placeholder="Puntaje opción A">
                                </div>
                            </div>
                        </div>

                        <div class="row" formGroupName="opcB">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Texto opción B</label>
                                    <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                </div>
                            </div>
                            <div class="col-md-6">    
                                <div class="form-group">
                                    <label class="control-label">Puntaje opción B</label>
                                    <input formControlName="value" type="number" class="form-control" placeholder="Puntaje opción B">
                                </div>
                            </div>
                        </div>

                        <div class="row" formGroupName="opcC">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Texto opción C</label>
                                    <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                </div>
                            </div>
                            <div class="col-md-6">    
                                <div class="form-group">
                                    <label class="control-label">Puntaje opción C</label>
                                    <input formControlName="value" type="number" class="form-control" placeholder="Puntaje opción C">
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label">Factor</label>
                                <select formControlName="factor" class="form-control custom-select">
                                    <option value="A">A</option>
                                    <option value="B">B</option>
                                    <option value="C">C</option>
                                    <option value="D">D</option>
                                    <option value="E">E</option>
                                    <option value="F">F</option>
                                    <option value="G">G</option>
                                    <option value="H">H</option>
                                    <option value="I">I</option>
                                    <option value="L">L</option>
                                    <option value="M">M</option>
                                    <option value="N">N</option>
                                    <option value="O">O</option>
                                    <option value="Q1">Q1</option>
                                    <option value="Q2">Q2</option>
                                    <option value="Q3">Q3</option>
                                    <option value="Q4">Q4</option>

                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">    
                            <div class="form-group">
                                <label class="control-label">Ìndice</label>
                                <input formControlName="index" type="number" class="form-control" placeholder="Índice">
                            </div>
                        </div>
                    </div>
   
                 
                    
                </div>
                <div class="form-actions">
                    <button type="submit" class="btn btn-success"> <i class="fa fa-check"></i> Actualizar</button>
                </div>
            </form>
            <div class="modal-footer">
                <button type="button" class="btn btn-info waves-effect" data-dismiss="modal">Cerrar</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->